import React, { lazy } from "react";
import UIDs from "../../UIDs";

const ItemsScreen = lazy(() => import("../../screens/admin/equipment/ItemsScreen"));
const HomeScreen = lazy(() => import("../../screens/admin/equipment/HomeScreen"));
const CategoriesScreen = lazy(() => import("../../screens/admin/equipment/CategoriesScreen"));
const CheckoutsScreen = lazy(() => import("../../screens/admin/equipment/CheckoutsScreen"));
const ReservationsScreen = lazy(() => import("../../screens/admin/equipment/ReservationsScreen"));
const ManagersScreen = lazy(() => import("../../screens/admin/equipment/ManagersScreen"));
const EditManagerScreen = lazy(() => import("../../screens/admin/equipment/EditManagerScreen"));
const EditCheckoutScreen = lazy(() => import("../../screens/admin/equipment/EditCheckoutScreen"));
const EditReservationScreen = lazy(() => import("../../screens/admin/equipment/EditReservationScreen"));
const ViewItemScreen = lazy(() => import("../../screens/admin/equipment/ViewItemScreen"));
const EditItemScreen = lazy(() => import("../../screens/admin/equipment/EditItemScreen"));

const FacilityAccessScreen = lazy(() => import("../../screens/admin/facility/FacilityAccessScreen"));
const FacilityLiveViewScreen = lazy(() => import("../../screens/admin/facility/FacilityLiveViewScreen"));
const EditFacilityAccessScreen = lazy(() => import("../../screens/admin/facility/EditFacilityAccessScreen"));
const FacilityAccessHistoryScreen = lazy(() => import("../../screens/admin/facility/FacilityAccessHistoryScreen"));
const FacilityCheckInScreen = lazy(() => import("../../screens/admin/facility/FacilityCheckInScreen"));
const DashboardScreen = lazy(() => import("../../screens/admin/DashboardScreen.jsx"));
const ProductListScreen = lazy(() => import('../../screens/admin/products/list.jsx'));
const ProductDetailsScreen = lazy(() => import('../../screens/admin/products/details.jsx'));
const ProductCreateScreen = lazy(() => import('../../screens/admin/products/create.jsx'));
const OrderCreateScreen = lazy(() => import('../../screens/admin/order/create.jsx'));
const OrderListScreen = lazy(() => import('../../screens/admin/order/list.jsx'));
const OrderDetailsScreen = lazy(() => import('../../screens/admin/order/details.jsx'));
const EcommerceScreen = lazy(() => import('../../screens/admin/e-commerce.jsx'));
const InvoiceCreateScreen = lazy(() => import('../../screens/admin/invoices/create.jsx'));
const InvoiceListScreen = lazy(() => import('../../screens/admin/invoices/list.jsx'));
const InvoiceDetailsScreen = lazy(() => import('../../screens/admin/invoices/details.jsx'));
const InvoiceScreen = lazy(() => import('../../screens/admin/invoices/invoice.jsx'));
const CheckoutScreen = lazy(() => import('../../screens/admin/checkout.jsx'));

// Shop screens
const ShopProductListScreen = lazy(() => import('../../screens/admin/shop/products/ProductListScreen.jsx'));
const ShopProductEditScreen = lazy(() => import('../../screens/admin/shop/products/ProductEditScreen.jsx'));
const ShopProductDetailScreen = lazy(() => import('../../screens/admin/shop/products/ProductDetailScreen.jsx'));
const ShopCartScreen = lazy(() => import('../../screens/admin/shop/cart/CartScreen.jsx'));

// Shop orders screens
const ShopOrderListScreen = lazy(() => import('../../screens/admin/shop/orders/OrderListScreen.jsx'));
const ShopOrderDetailScreen = lazy(() => import('../../screens/admin/shop/orders/OrderDetailScreen.jsx'));
const ShopCheckoutScreen = lazy(() => import('../../screens/admin/shop/checkout/CheckoutScreen.jsx'));
const FacilityCalendarScreen = lazy(() => import("../../screens/portal/FacilityCalendarScreen.jsx"));
const OfferingsScreen = lazy(() => import("../../screens/portal/OfferingsScreen.jsx"));
const CalendarListScreen = lazy(() => import("../../screens/admin/eventcalendar/CalendarListScreen.jsx"));
const EditCalendarScreen = lazy(() => import("../../screens/admin/eventcalendar/EditCalendarScreen.jsx"));

const MyMembershipsScreen = lazy(() => import("../../screens/admin/MyMembershipsScreen.jsx"));

export const adminRoutes = [
    {
        path: "/dashboard",
        uid: UIDs.screens.admin.dashboard,
        layout: "/admin",
        element: DashboardScreen,
    },
    {
        path: "/products/list",
        uid: UIDs.screens.admin.products.list,
        layout: "/admin",
        element: ProductListScreen,
    },
    {
        path: "/products/create",
        uid: UIDs.screens.admin.products.create,
        layout: "/admin",
        element: ProductCreateScreen,
    },
    {
        path: "/products/:id",
        uid: UIDs.screens.admin.products.details,
        layout: "/admin",
        element: ProductDetailsScreen,
    },
    {
        path: "/order/create",
        uid: UIDs.screens.admin.order.create,
        layout: "/admin",
        element: OrderCreateScreen,
    },
    {
        path: "/order/list",
        uid: UIDs.screens.admin.order.list,
        layout: "/admin",
        element: OrderListScreen,
    },
    {
        path: "/order/:id",
        uid: UIDs.screens.admin.order.details,
        layout: "/admin",
        element: OrderDetailsScreen,
    },
    {
        path: "/ecommerce",
        uid: UIDs.screens.admin.ecommerce,
        layout: "/admin",
        element: EcommerceScreen,
    },
    {
        path: "/invoices/create",
        uid: UIDs.screens.admin.invoices.create,
        layout: "/admin",
        element: InvoiceCreateScreen,
    },
    {
        path: "/invoices/list",
        uid: UIDs.screens.admin.invoices.list,
        layout: "/admin",
        element: InvoiceListScreen,
    },
    {
        path: "/invoices/:id",
        uid: UIDs.screens.admin.invoices.details,
        layout: "/admin",
        element: InvoiceDetailsScreen,
    },
    {
        path: "/invoices/invoice/:id",
        uid: UIDs.screens.admin.invoices.invoice,
        layout: "/admin",
        element: InvoiceScreen,
    },
    {
        path: "/checkout",
        uid: UIDs.screens.admin.checkout,
        layout: "/admin",
        element: CheckoutScreen,
    },
    {
        path: "/facility/facilityaccess",
        uid: UIDs.screens.admin.facility.facilityaccess,
        layout: "/admin",
        element: FacilityAccessScreen ,
    },
    {
        path: "/facility/facilityliveview",
        uid: UIDs.screens.admin.facility.facilityliveview,
        layout: "/admin",
        element: FacilityLiveViewScreen,
    },
    {
        path: "/facility/editfacilityaccess",
        uid: UIDs.screens.admin.facility.editfacilityaccess,
        layout: "/admin",
        element: EditFacilityAccessScreen,
    },
    {
        path: "/facility/facilityaccesshistory",
        uid: UIDs.screens.admin.facility.facilityaccesshistory,
        layout: "/admin",
        element: FacilityAccessHistoryScreen,
    },
    {
        path: "/facility/facilitycheckin",
        uid: UIDs.screens.admin.facility.facilitycheckin,
        layout: "/admin",
        element: FacilityCheckInScreen,
    },
    {
        path: "/equipment/items",
        uid: UIDs.screens.admin.equipment.items,
        layout: "/admin",
        element: ItemsScreen,
    },
    {
        path: "/equipment/viewitem",
        uid: UIDs.screens.admin.equipment.viewitem,
        layout: "/admin",
        element: ViewItemScreen,
    },
    {
        path: "/equipment/edititem",
        uid: UIDs.screens.admin.equipment.edititem,
        layout: "/admin",
        element: EditItemScreen,
    },
    {
        path: "/equipment/home",
        uid: UIDs.screens.admin.equipment.home,
        layout: "/admin",
        element: HomeScreen,
    },
    {
        path: "/equipment/categories",
        uid: UIDs.screens.admin.equipment.categories,
        layout: "/admin",
        element: CategoriesScreen,
    },
    {
        path: "/equipment/checkouts",
        uid: UIDs.screens.admin.equipment.checkouts,
        layout: "/admin",
        element: CheckoutsScreen,
    },
    {
        path: "/equipment/reservations",
        uid: UIDs.screens.admin.equipment.reservations,
        layout: "/admin",
        element: ReservationsScreen,
    },
    {
        path: "/equipment/managers",
        uid: UIDs.screens.admin.equipment.managers,
        layout: "/admin",
        element: ManagersScreen,
    },
    {
        path: "/equipment/editmanager",
        uid: UIDs.screens.admin.equipment.editmanager,

        layout: "/admin",
        element: EditManagerScreen,
    },
    {
        path: "/equipment/editcheckout",
        uid: UIDs.screens.admin.equipment.editcheckout,
        layout: "/admin",
        element: EditCheckoutScreen
    },
    {
        path: "/equipment/editreservation",
        uid: UIDs.screens.admin.equipment.editreservation,
        layout: "/admin",
        element: EditReservationScreen,
    },
    // Shop routes
    {
        path: "/shop/products/list",
        uid: UIDs.screens.admin.shop.products.list,
        layout: "/admin",
        element: ShopProductListScreen,
    },
    {
        path: "/shop/products/edit",
        uid: UIDs.screens.admin.shop.products.edit,
        layout: "/admin",
        element: ShopProductEditScreen,
    },
    {
        path: "/shop/products/detail",
        uid: UIDs.screens.admin.shop.products.detail,
        layout: "/admin",
        element: ShopProductDetailScreen,
    },
    {
        path: "/shop/cart",
        uid: UIDs.screens.admin.shop.cart.cart,
        layout: "/admin",
        element: ShopCartScreen,
    },
    // Shop orders routes
    {
        path: "/shop/orders/list",
        uid: UIDs.screens.admin.shop.orders.list,
        layout: "/admin",
        element: ShopOrderListScreen,
    },
    {
        path: "/shop/orders/detail",
        uid: UIDs.screens.admin.shop.orders.detail,
        layout: "/admin",
        element: ShopOrderDetailScreen,
    },
    {
        path: "/shop/checkout",
        uid: UIDs.screens.admin.shop.checkout.checkout,
        layout: "/admin",
        element: ShopCheckoutScreen,
    },
    {
        path: "/facilitycalendar",
        uid: UIDs.screens.portal.facilitycalendar,
        layout: "/admin",
        element: FacilityCalendarScreen,
        exact: true,
    },
    {
        path: "/mymemberships",
        uid: UIDs.screens.admin.mymemberships,
        layout: "/admin",
        element: MyMembershipsScreen,
    },
    {
        path: "/offerings",
        uid: UIDs.screens.admin.offerings,
        layout: "/admin",
        element: OfferingsScreen,
        exact: true,
    },
    {
        path: "/eventcalendar/calendarlist",
        uid: UIDs.screens.admin.eventcalendar.calendarlist,
        layout: "/admin",
        element: CalendarListScreen,
    },
    {
        path: "/eventcalendar/editcalendar",
        uid: UIDs.screens.admin.eventcalendar.editcalendar,
        layout: "/admin",
        element: EditCalendarScreen,
    },
];

